// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".stack > * + * {\n  margin-top: 16px;\n}\n", "",{"version":3,"sources":["webpack://src/components/Stack.css"],"names":[],"mappings":"AACE;EACE,gBAAgB;AAClB","sourcesContent":[".stack {\n  & > * + * {\n    margin-top: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
